module.exports = __webpack_public_path__ + "static/media/logoWithSlogenAR.1d393823.png";